class ProductMedia extends HTMLElement {

  constructor() {
    super();
    this.itemsHolder = this.querySelector('product-media-items');
    this.displayItems = this.querySelector('product-media-display');
    this.nextButton = this.querySelector('product-media-next');
    this.prevButton = this.querySelector('product-media-prev');
    this.counter = this.querySelector('product-media-counter');
    this.initialMedia = this.dataset.initialMediaId;
  }

  connectedCallback() {
    if(this.itemsHolder) {
      setTimeout(() => {
        this.reload();
        this.displayItems.setImage(this.initialMedia || this.itemsHolder.items[0].mediaId)
        this.displayItems.reload();
      })
    }
    else {
      setTimeout(() => {
        this.displayItems.setImage(this.querySelector('[data-media-id]').dataset.mediaId)
      })
    }
  }

  nextItem() {
    this.itemsHolder.nextItem();
  }

  prevItem() {
    this.itemsHolder.prevItem();
  }

  reload() {
    this.itemsHolder.getItems();
    this.itemsHolder.setColumnDimensions();
  }

  setImage(imageId) {
    this.displayItems.setImage(imageId);
  }

}

class ProductMediaDisplay extends HTMLElement {

  constructor() {
    super();
    this._height = 0;
    this.media = false;
    this.image = false;

    window.addEventListener('resize', () => {
      this.reload();
    });
  }

  reload() {
    this.calcHeight(this.image);
  }

  setImage(imageId) {
    if(this.media) {
      this.media.setAttribute('data-state', 'inactive');
    }
    this.image = this.querySelector(`[data-media-id="${imageId}"]`);
    this.media = this.image.closest('.media');
    this.calcHeight(this.image);
    this.media.setAttribute('data-state', 'active');
  }

  calcHeight(el) {
    if(this.classList.contains('aspect-square')) {
      this.height = '100%';
      return;
    }
    const clone = el.cloneNode(true);
    Object.assign(clone.style, {
      height: 'auto',
      width: '100%',
      maxHeight: 'none',
      opacity: '0',
      visibility: 'hidden',
      display: 'block'
    });
    this.append(clone);
    this.height = clone.offsetHeight;
    clone.remove();
  }

  set height(height) {
    this._height = height;
    this.style.height = typeof height === 'number' ? `${height}px` : height;
  }

  get height() {
    return this._height;
  } 
}

class ProductMediaItems extends HTMLElement {
  constructor() {
    super();
    this.minHeight = 0;
    this.columnWidth = 0;
    this.smallBreakpoint = 1024;
    this.desktopView = true;
    this.selectedImage = false;
    this.selectedIndex = 0;
    this.width = 0;
    this.parent = this.closest('product-media');
    if(!this.parent) {
      console.error('No parent product media element found.');
      return;
    }

    window.addEventListener('resize', () => {
      this.setColumnDimensions();
    });
  }

  getItems() {
    this.items = this.querySelectorAll('product-media-item');
    if(this.items.length > 0) {
      this.selectedImage = this.items[0];
    }
  }

  setColumnDimensions() {
    this.desktopView = window.innerWidth > this.smallBreakpoint;
    // Position of the buttons will impact the column sizes.
    if(this.selectedIndex !== 0) {
      this.parent.prevButton.show();
    }
    else {
      this.parent.prevButton.hide();
    }
    if(this.selectedIndex !== this.items.length - 1) {
      this.parent.nextButton.show();
    }
    else {
      this.parent.nextButton.hide();
    }
    const style = getComputedStyle(this);
    this.width = parseFloat(style.width);
    this.columnWidth = this.desktopView 
      ? (this.width / this.desktopColumns) - (this.columnGap * (this.desktopColumns - 1) / this.desktopColumns)
      : (this.width / this.mobileColumns) - (this.columnGap * (this.mobileColumns - 1) / this.mobileColumns);
    const heights = [];
    if(!this.items) {
      return false;
    }
    this.items.forEach((i,k) => {
      i.style.minWidth = `${this.columnWidth}px`;
      i.style.width = `${this.columnWidth}px`;
      i.style.marginRight = `${this.columnGap}px`;
      i.style.height = 'auto';
      heights.push(i.getBoundingClientRect().height);
      i.style.translate = `${(k - this.selectedIndex) * (this.columnWidth + this.columnGap)}px`;
    });
    const extraHeight = parseFloat(style.paddingBottom) + parseFloat(style.paddingTop) + parseFloat(style.marginTop) + parseFloat(style.marginBottom);
    const maxHeight = Math.max(...heights);
    this.minHeight = ((maxHeight > 120 && this.ratio !== 'aspect-square') ? 120 : maxHeight) + extraHeight;
    this.items.forEach((i,k) => {
      i.style.height = `${this.minHeight}px`;
    });
    this.style.minHeight = `${this.minHeight}px`
  }

  get ratio() {
    return this.getAttribute('ratio');
  }

  get desktopColumns() {
    return parseInt(this.getAttribute('desktop-columns') ?? 4);
  }

  set desktopColumns(columns) {
    this.setAttribute('desktop-columns', columns);
  }

  get mobileColumns() {
    return parseInt(this.getAttribute('mobile-columns') ?? 1);
  }

  set mobileColumns(columns) {
    this.setAttribute('mobile-columns', columns);
  }

  get columnGap() {
    return parseFloat(this.getAttribute('column-gap') ?? 16);
  }

  set columnGap(columns) {
    this.setAttribute('mobile-columns', columns);
  }

  get numColumns() {
    return this.desktopView ? this.desktopColumns : this.mobileColumns;
  }

  nextItem() {
    this.jumpTo(this.selectedIndex + 1);
  }

  prevItem() {
    this.jumpTo(this.selectedIndex - 1);
  }

  jumpTo(index) {
    if(this.items[index] === undefined) {
      return false;
    }
    this.selectedIndex = index;
    const visibleIndex = [...this.items].findIndex(i => {
      return this.parent.displayItems.image == i;
    })
    if(visibleIndex === index) {
      return false;
    }
    const columnWidth = this.columnWidth + this.columnGap;
    this.items.forEach(i => {
      const currPos = parseFloat(i.style.translate)
      if(index > visibleIndex) {
        i.style.translate = `${(currPos) - (columnWidth * (index - visibleIndex))}px`;
      }
      else if(index < visibleIndex) {
        i.style.translate = `${(currPos) + (columnWidth * (visibleIndex - index))}px`;
      }
    })
    this.setColumnDimensions();
    this.parent.setImage(this.items[index].mediaId);
    this.parent.counter.innerHTML = `${this.selectedIndex + 1}`
  }

  disableTransitions() {
    this.items.forEach(i => {
      i.disableTransition();
    })
  }

  enableTransitions() {
    this.items.forEach(i => {
      i.enableTransition();
    })
  }
}

class ProductMediaItem extends HTMLElement {

  constructor() {
    super();
    this.screenX = 0;
    this.setDefaultStyle();
    this.holder = this.closest('product-media-items');
    this.handleSelect = this.setActive.bind(this);
    this.handleDrag = this.checkDragged.bind(this);
  }

  connectedCallback() {
    const items = this.closest('product-media-items').querySelectorAll('product-media-item');
    this.itemIndex = [...items].findIndex(i => {
      return i === this
    });
    this.addEventListener('click', this.handleSelect);
    this.addEventListener('touchstart', this.setPageX.bind(this));
    this.addEventListener('touchend', this.handleDrag);
  }

  setDefaultStyle() {
    this.style.position = 'absolute';
    this.style.height = '100%';
    this.enableTransition();
  }

  disableTransition () {
    this.style.transition = 'none';
  }

  enableTransition () {
    this.flushCss();
    this.style.transition = 'translate 500ms';
  }

  flushCss() {
    this.offsetHeight;
  }

  setActive() {
    this.holder.jumpTo(this.itemIndex);
  }

  setPageX(e) {
    const evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    this.screenX = touch.screenX;
  }

  checkDragged(e) {
    const evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    if(touch.screenX < this.screenX) {
      if((this.screenX - touch.screenX) > 40) {
        this.nextItem();
      }
    }
    else if(touch.screenX > this.screenX) {
      if((touch.screenX - this.screenX) > 40) {
        this.prevItem();
      }
    }
  }

  nextItem() {
    this.holder.jumpTo(this.itemIndex + 1);
  }

  prevItem() {
    this.holder.jumpTo(this.itemIndex - 1);
  }

  get mediaId() {
    return this.dataset.mediaId;
  }

  set mediaId(id) {
    this.setAttribute('data-media-id', id);
  }

}

class ProductMediaNav extends HTMLElement {

  constructor() {
    super();
    this.parent = this.closest('product-media');
  }

  prevItem() {
    this.parent.prevItem();
  }

  nextItem() {
    this.parent.nextItem();
  }

  hide() {
    this.setAttribute('data-state', 'disabled');
  }

  show() {
    this.setAttribute('data-state', 'active')
  }

}

class ProductMediaPrev extends ProductMediaNav {
  constructor() {
    super();
    this.addEventListener('click', this.prevItem.bind(this));
  }
}

class ProductMediaNext extends ProductMediaNav {
  constructor() {
    super();
    this.addEventListener('click', this.nextItem.bind(this));
  }
}

customElements.define('product-media', ProductMedia);
customElements.define('product-media-display', ProductMediaDisplay);
customElements.define('product-media-items', ProductMediaItems);
customElements.define('product-media-item', ProductMediaItem);
customElements.define('product-media-nav', ProductMediaNav);
customElements.define('product-media-prev', ProductMediaPrev);
customElements.define('product-media-next', ProductMediaNext);